import { render, staticRenderFns } from "./NumberOfBoxModal.vue?vue&type=template&id=ee19886e"
import script from "./NumberOfBoxModal.vue?vue&type=script&lang=js"
export * from "./NumberOfBoxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports